<script>
import { useAlert } from 'dashboard/composables';
import { mapGetters } from 'vuex';
import PixelForm from './PixelForm.vue';

export default {
  components: { PixelForm },
  props: {
    onClose: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      uiFlags: 'metaCapiPixels/getUIFlags',
    }),
  },
  methods: {
    async onSubmit(pixel) {
      try {
        await this.$store.dispatch('metaCapiPixels/create', {
          meta_capi_pixel: pixel,
        });
        useAlert(this.$t('META_CAPI_PIXELS.ADD.API.SUCCESS_MESSAGE'));
        this.onClose();
      } catch (error) {
        const message =
          error?.response?.data?.message ||
          this.$t('META_CAPI_PIXELS.ADD.API.ERROR_MESSAGE');
        useAlert(message);
      }
    },
  },
};
</script>

<template>
  <div class="h-auto overflow-auto flex flex-col">
    <woot-modal-header
      :header-title="$t('META_CAPI_PIXELS.ADD.TITLE')"
      :header-content="$t('META_CAPI_PIXELS.ADD.DESC')"
    />
    <PixelForm
      :is-submitting="uiFlags.creatingItem"
      :submit-label="$t('META_CAPI_PIXELS.FORM.ADD_SUBMIT')"
      @submit="onSubmit"
      @cancel="onClose"
    />
  </div>
</template>
